import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';

//import img
import recordsImg from '../../../../assets/icons/records.svg';

//import components
import DownloadFormats from '../../../formats-to-download/DownloadFormats.js';

const PageHeaderRecord = ({ clang, name }) => {
	return (
		<div className="record__page-header">
			<div className="record__main-header">
				<img src={ recordsImg } alt={ lang[ clang ].alt.record } className="record__main-header__img" />
				<h3 className="record__header-name">{ lang[ clang ].headers.record }</h3>
				<h4 className="record__header-subname">{ name }</h4>
			</div>
			<DownloadFormats lang={ lang }/>
		</div>
	);
};

PageHeaderRecord.propTypes = {
	clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PageHeaderRecord);



// WEBPACK FOOTER //
// ./src/components/items/records/common/PageHeaderRecord.js